<script lang="ts" setup>
import { computed } from 'vue';

interface Props {
  name?: string;
  backgroundColor?: string;
  textColor?: string;
}

const props = defineProps<Props>();

const initial = computed(() => {
  if (!props.name) {
    return '';
  }
  return props.name.trim().charAt(0).toUpperCase();
});
</script>

<template>
  <div data-ui-component="UiAvatar" :class="$style.root" :style="{ backgroundColor: props.backgroundColor }">
    <span :class="$style.initial" :style="{ color: props.textColor }">
      <slot>
        {{ initial }}
      </slot>
    </span>
  </div>
</template>

<style lang="scss" module>
.root {
  flex: none;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 20px;
  height: 20px;
  border-radius: 50%;
  color: #f5f5f5;
  background-color: #a078a9;
  font-size: 12px;
  line-height: 1;
  font-weight: 400;
}

.initial {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 100%;
  height: 100%;
}
</style>
